import React, {
	Component,
	PropTypes
} from 'react';
import render from "react-dom";
import {
	Link
} from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
var moment = require("moment");
import Tip from 'CONFIG/component/tip'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
import {language, pageOption} from 'UTIL/common'
import SearchDate from 'CONFIG/component/search/searchDate'
import ellaService from 'SERVICES/purifier/ella/ellaService'
import {timesTampsToData} from 'CONFIG/function'
export default class EmailIndex extends Component {
	constructor(props) {
		super(props);
		this.search = this.search.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.state = {
			list: [],
			size: 10,
			current: 1,
			total: 0,
		};
	}
	componentDidMount() {
		$("#time").val('');
		this.onPageChange(1, this.state.size);
	}
	
	onPageChange(page, sizePerPage, e) {
        const search = $.trim($("#search").val());
        var gmtCreateBgn = $("#time").val()==""?"":$("#time").val().split("至")[0];
        var gmtCreateEnd = $("#time").val()==""?"":$("#time").val().split("至")[1];
		const json = {
			current:page,
            size:sizePerPage,
			search: search,
			satrtTime:gmtCreateBgn,
			endTime:gmtCreateEnd
		};
		var data =  JSON.stringify(json)
		ellaService.emailLog({data}).then(body => {
            console.log(body)
            if (body.code == 8001) {
                this.setState({
                    current: body.data.current,
					size: body.data.size,
                    list : body.data.records,
                    total : body.data.total
                })
            }
        })
	}
	search() {
		this.onPageChange(1, this.state.size);
	}

    dateFormate(cell,row){
		return row.gmtSend == null?"":timesTampsToData(row.gmtSend);
	}
	reset() {
        $("#search").val('');
        $("#time").val('');
        this.onPageChange(1, 10)
    }
	render() {
		
		const options = {
            noDataText:"没找到数据",
            page: this.state.current, //当前页
            sizePerPageList: [10, 15, 20],
            sizePerPager: this.state.pageSize,
            pageStartIndex: 1,
            paginationSize: 5,
            firstPage: '首页',
            lastPage: '尾页',
            onPageChange: this.onPageChange,
        }
		return (
			<div>
				<section className="content-header " >
			            <h1>邮件信息 <small>邮件列表</small> </h1>
			            </section>
			             <section className="content" >
		             		<div className="box box-primary color-palette-box">
		                 			 <div className="box-header with-border">
		                   				 <i className="fa fa-list"></i>
		                    				<h3 className="box-title">邮件列表</h3>
		                    				<div style={{marginRight:"10px",float:"right"}}>
						            </div>
		                  			</div>
		                  			<div className="box-body">
		                       				 <Tip ids=""/>
												<div className="title-box">
													<div className="clearfix">
														<LongSearchInput id="search" name="邮箱账号/邮件内容"/>
														<SearchDate name="sendTime" id="time"/>
														<button type="button" className="btn btn-info" id="search"
																onClick={this.search.bind(this)}>{language()['query']}</button>
														&nbsp;&nbsp;
														<button type="button" className="btn btn-warning" id="reset"
																onClick={this.reset.bind(this)}>{language()['resetting']}</button>
													</div>
                           						 </div>
			                    			<div >
				                        			<BootstrapTable data = {this.state.list}  remote={true} fetchInfo={{ dataTotalSize: this.state.total }} striped hover pagination={true} options={options} ref='table' >
				                        				<TableHeaderColumn isKey dataField='id' hidden={true}> id</TableHeaderColumn>
				                        				<TableHeaderColumn dataField='email' width={'180'} > 邮箱账号 </TableHeaderColumn>
				                        				<TableHeaderColumn  dataField='content' width={'560'} >邮件内容</TableHeaderColumn>
				                        				<TableHeaderColumn  dataField='gmtSend' dataFormat={this.dateFormate}>发送时间</TableHeaderColumn>
				                        			</BootstrapTable>
		                  				</div>
		                  			</div>
		                		</div>
		             	</section>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./modules/ella/user/email/emailIndex.js